import { render, staticRenderFns } from "./addEvalsModal.vue?vue&type=template&id=8565d5be&"
import script from "./addEvalsModal.vue?vue&type=script&lang=js&"
export * from "./addEvalsModal.vue?vue&type=script&lang=js&"
import style0 from "./addEvalsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports